// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__lIPwW","options":"AnswerScale_options__2EujT","selected":"AnswerScale_selected__1Yccl"};